import React from 'react'
import * as Fields from 'support/fields'
import { ModelWithForm } from '@morningtrain/react-resources'
import Button from 'ui/buttons/Button'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation } from '@morningtrain/react-translations'
import { PageHeader } from 'ui/layouts'
import Fieldset from 'layouts/form/Fieldset'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { NavigateOnPipe } from '@morningtrain/react-navigation'
import * as UI from 'ui'

export default function DepartmentSupplierEditForm ({ create = false }) {
  const resourceName = 'department_suppliers'

  return (
    <ModelWithForm resourceName={resourceName}>
      <PageHeader title={<TranslatedTitle name={'titles.' + (create ? 'create' : 'edit')} />}>
        <div className='flex space-x-4'>
          <DeleteModelOnClick pipes={<NavigateOnPipe route='app.settings.department_suppliers.index' />}>
            <Button color='outlineRed' text={<Translation name='actions.delete' />} />
          </DeleteModelOnClick>
          <Button text={<Translation name='actions.save' />} type='submit' />
        </div>
      </PageHeader>
      <UI.CardGroup>
        <UI.Card>
          <Fieldset cols={2}>
            <Fields.Input name="name" label={<Translation name="fields.name.label"/>}/>
            <Fields.Input name="address" label={<Translation name="fields.address.label"/>}/>
            <Fields.Input name="cvr" label={<Translation name="fields.cvr.label"/>}/>
            <Fields.ResourceSelector
                    resourceName="departments"
                    name="department_ids"
                    multiple
                    label={<Translation name="fields.departments.label"/>}
                    optionsKey="name"
            />
          </Fieldset>
          <Fieldset cols={3}>
            <Fields.Input name={'phone_number'} label={<Translation name="fields.phone.label"/>}/>
            <Fields.Input name={'description'} label={<Translation name="fields.description.label"/>}/>
            <Fields.Input name={'customer_id'} label={<Translation name="fields.customer_id.label"/>}/>
          </Fieldset>
        </UI.Card>
        <UI.Card>
          <Fields.Repeater name="contacts" label={<Translation name="fields.contacts.label"/>}>
            <Fields.Hidden name="id"/>
            <Fields.Input name="name" label={<Translation name="fields.name.label"/>}/>
            <Fields.Input name="position" label={<Translation name="fields.position.label"/>}/>
            <Fields.Input name="email" label={<Translation name="fields.email.label"/>}/>
            <Fields.Input name="phone" type="tel" label={<Translation name="fields.phone.label"/>}/>
          </Fields.Repeater>
        </UI.Card>
      </UI.CardGroup>
      <RedirectToEditOnCreatePipeline routeName='app.settings.department_suppliers.edit' />
    </ModelWithForm>
  )
}
